import { ButtonHTMLAttributes, useState } from "react";
import Button from "components/Buttons/Button/Button";
import AddOperationsNoteModal from "components/Modals/AddOperationsNoteModal/AddOperationsNoteModal";

interface AddOperationsNoteButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  onSuccess: () => void;
  onError: () => void;
}

const AddOperationsNoteButton = (props: AddOperationsNoteButtonProps) => {
  const { onSuccess, onError, ...rest } = props;

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <Button {...rest} onClick={() => setIsModalOpen(true)}>
        Add Note
      </Button>

      {isModalOpen && (
        <AddOperationsNoteModal
          onClose={() => setIsModalOpen(false)}
          onSuccess={onSuccess}
          onError={onError}
        />
      )}
    </>
  );
};

export default AddOperationsNoteButton;
